class FeaturedCollectionTabs extends HTMLElement {
  constructor() {
    super();
    this.tabButtons = this.querySelectorAll('.tab-button');
    this.tabPanes = this.querySelectorAll('.tab-pane');
    this.activeClass = 'active';
    this.hiddenClass = 'hidden';
  }

  connectedCallback() {
    this.tabButtons.forEach(button => {
      button.addEventListener('click', (event) => this.switchTab(event));
    });
  }

  switchTab(event) {
    const targetButton = event.currentTarget;
    const targetId = targetButton.getAttribute('data-id');

    // Deactivate all tabs and hide all panes
    this.tabButtons.forEach(button => button.classList.remove(this.activeClass));
    this.tabPanes.forEach(pane => pane.classList.add(this.hiddenClass));

    // Activate the clicked tab and show the corresponding pane
    targetButton.classList.add(this.activeClass);
    this.querySelector(`.tab-pane[data-block-id="${targetId}"]`).classList.remove(this.hiddenClass);
  }
}

customElements.define('featured-collection-tabs', FeaturedCollectionTabs);

const cartIconEl = document.querySelector('#cart-icon-bubble');
let rebuyEventListenerAdded = false;

cartIconEl && cartIconEl.addEventListener('click', (evt) => {
  if (window.Rebuy?.SmartCart?.status === 'ready' || rebuyEventListenerAdded) return;

  evt.preventDefault();

  // Set the flag to avoid adding duplicate listeners
  rebuyEventListenerAdded = true;
  document.addEventListener('rebuy:smartcart.ready', () => {
    // Add a slight delay to allow the SmartCart open animation to play.
    // Without this timeout, the cart would show immediately without the slide-in effect.
    setTimeout(function() {
      window.Rebuy.SmartCart.show();
      rebuyEventListenerAdded = false;
    })
  });
});

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

// var accordions = document.querySelectorAll('.accordion');
// accordions.forEach(accordion => {

//   let details = accordion.querySelector('details');
//   let summary = details.querySelector('summary');
//   let image_with_text = accordion.closest('.image-with-text');

//   summary.addEventListener('click', (e) => {
//     e.preventDefault();

//     if(image_with_text) {
//       let image_with_text_accordions = image_with_text.querySelectorAll('details');
//       image_with_text_accordions.forEach(image_with_text_accordion => {
//         if (image_with_text_accordion !== details) {
//           image_with_text_accordion.removeAttribute('open');
//         }
//       });

//       if (details.hasAttribute('open')) {
//         details.removeAttribute('open');
//       } else {
//         details.setAttribute('open', true);
//       }
//     }

//   });
// });

var scroll_links = document.querySelectorAll('a.smooth-scroll');
if (scroll_links.length > 0) scroll_links.forEach(link => link.addEventListener('click', (e) => {

  e.preventDefault();

  var element = document.querySelector(e.target.closest('a.smooth-scroll').getAttribute('href'));
  var headerOffset = document.querySelector('sticky-header').offsetHeight;

  if (element) {
    var elementPosition = element.getBoundingClientRect().top;
    var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  }

}));

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('.js-drawer-has-sub-menu').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');
    document.body.classList.add('drawer-menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    document.body.classList.remove('drawer-menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.paginationContainer = this.querySelector('.slider-pagination');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

    const containerWidth = this.slider.clientWidth;
    const itemWidth = this.sliderItemsToShow[0].clientWidth;
    const itemsPerView = containerWidth / itemWidth;

    this.slidesPerPage = Math.floor(
        (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );


    if (itemsPerView < 1.5) {
      this.totalPages = this.sliderItemsToShow.length;
    } else {
      const itemsFitFullyInScreen = Math.floor(itemsPerView) >= this.slidesPerPage;

      if (itemsFitFullyInScreen) {
        // Items show completely in screen - don't add +1
        this.totalPages = Math.max(1, this.sliderItemsToShow.length - this.slidesPerPage);
      } else {
        // Items don't fit fully (some part is cut off) - need +1 for partial views
        this.totalPages = Math.max(1, this.sliderItemsToShow.length - this.slidesPerPage + 1);
      }
    }

    this.createPaginationDots()
    this.update();
  }

  createPaginationDots() {
    if (!this.paginationContainer) return;
    this.paginationContainer.innerHTML = '';
    for (let i = 1; i <= this.totalPages; i++) {
      const dot = document.createElement('button');
      dot.className = `pagination-dot ${i == 1 ? 'active' : ''}`;
      dot.dataset.page = i;
      dot.addEventListener('click', (e) => this.goToPage(Number(e.target.dataset.page)));
      this.paginationContainer.appendChild(dot);
    }
  }

  goToPage(pageNumber) {
    const position = (pageNumber - 1) * this.sliderItemOffset;
    this.setSlidePosition(position);
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
      this.updatePaginationDots();
    }

    if (this.enableSliderLooping) return;

    this.sliderItemsToShow.forEach((item, index) => {
          if (this.isSlideVisible(item)) {
            item.classList.remove('out-of-view');
          } else {
            item.classList.add('out-of-view');
          }
        });

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  updatePaginationDots() {
    if (!this.paginationContainer) return;
    Array.from(this.paginationContainer.children).forEach((dot, index) => {
      dot.classList.toggle('active', index + 1 === this.currentPage);
    });
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);

    if (!this.sliderControlWrapper || !this.sliderItemsToShow) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow && this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button && button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class SlickySliderComponent extends HTMLElement {
  constructor() {
    super();
    this.mainSlider = null;
    this.thumbSlider = null;
    this.isFilteringVariantMedia = false;
    this.pendingMediaFrame = null;
    this.handleMainSliderAfterChange = this.handleMainSliderAfterChange.bind(this);
  }

  connectedCallback() {
    this.initSliders();
  }

  initSliders() {
    this.mainSlider = this.querySelector('.main-slider');
    this.thumbSlider = this.querySelector('.thumb-slider');

    if (!this.mainSlider || !this.thumbSlider) return;

    this.initMainSlider();
    this.initThumbSlider();
  }

  initMainSlider() {
    $(this.mainSlider).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      infinite: false,
      accessibility: true,
      prevArrow: this.querySelector('.main-prev'),
      nextArrow: this.querySelector('.main-next'),
      asNavFor: this.thumbSlider,
      responsive: [
        { breakpoint: 750, settings: { slidesToShow: 1 } },
      ],
    });

    $(this.mainSlider).on('afterChange', this.handleMainSliderAfterChange);
    this.filtertMainSlider();
  }

  initThumbSlider() {
    $(this.thumbSlider).slick({
      slidesToShow: 6,
      slidesToScroll: 3,
      infinite: false,
      focusOnSelect: true,
      arrows: true,
      accessibility: true,
      asNavFor: this.mainSlider,
      prevArrow: this.querySelector('.thumb-prev'),
      nextArrow: this.querySelector('.thumb-next'),
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 5 } },
        { breakpoint: 750, settings: { slidesToShow: 6 } },
      ],
    });

    this.filterThumbnails();

    $(this.thumbSlider).on('setPosition', () => {
      this.markThumbIfNotScrollable();
    });

    this.markThumbIfNotScrollable();
  }

  handleMainSliderAfterChange(_event, _slick, currentSlide) {
    if (this.isFilteringVariantMedia) return;

    const activeSlide = this.getMainSlides()[currentSlide];
    if (!activeSlide) return;

    this.setActiveThumbnailByMediaId(activeSlide.getAttribute('data-media-id'));
  }

  filtertMainSlider() {
    if (!this.mainSlider || !$(this.mainSlider).hasClass('slick-initialized')) return;

    $(this.mainSlider).slick('slickUnfilter');
    $(this.mainSlider).slick('slickFilter', function(index, element) {
      return !element.classList.contains('hide-media');
    });
  }

  filterThumbnails() {
    if (!this.thumbSlider || !$(this.thumbSlider).hasClass('slick-initialized')) return;

    $(this.thumbSlider).slick('slickUnfilter');
    $(this.thumbSlider).slick('slickFilter', function(index, element) {
      return !element.classList.contains('hide-media');
    });
  }

  goToMediaId(mediaId, instant = false) {
    if (!this.mainSlider || !$(this.mainSlider).hasClass('slick-initialized')) return;

    const mainIndex = this.getMainSlides().findIndex(slide => slide.getAttribute('data-media-id') === mediaId);
    const thumbnailIndex = this.getThumbnailSlides().findIndex(slide => slide.getAttribute('data-target') === mediaId);

    if (mainIndex >= 0) {
      this.setActiveThumbnailByMediaId(mediaId);

      if (this.pendingMediaFrame) cancelAnimationFrame(this.pendingMediaFrame);
      this.pendingMediaFrame = requestAnimationFrame(() => {
        this.pendingMediaFrame = null;

        $(this.mainSlider).slick('slickGoTo', mainIndex, instant);

        if (thumbnailIndex >= 0 && $(this.thumbSlider).hasClass('slick-initialized')) {
          $(this.thumbSlider).slick('slickGoTo', thumbnailIndex, instant);
        }

        this.setActiveThumbnailByMediaId(mediaId);
      });
    }
  }

  filterByVariantValues(variantValues) {
    if (!this.mainSlider || !this.thumbSlider) return false;

    const groupedSliders = [this.thumbSlider, this.mainSlider].filter((slider) => $(slider).hasClass('slick-initialized'));
    if (groupedSliders.length === 0) return false;

    let firstMediaId = null;
    this.isFilteringVariantMedia = true;

    try {
      groupedSliders.forEach((slider) => {
        $(slider).slick('slickUnfilter');

        slider.querySelectorAll('[data-image-group]').forEach((item) => {
          item.classList.add('hide-media');
        });

        variantValues.forEach((value) => {
          slider.querySelectorAll(`[data-image-group="${value}"]`).forEach((item) => {
            item.classList.remove('hide-media');
          });
        });
      });

      groupedSliders.forEach((slider) => {
        $(slider).slick('slickFilter', function (index, element) {
          return !element.classList.contains('hide-media');
        });
      });

      firstMediaId = this.getMainSlides()[0]?.getAttribute('data-media-id');
    } finally {
      this.isFilteringVariantMedia = false;
    }

    if (firstMediaId) this.setActiveThumbnailByMediaId(firstMediaId);

    return firstMediaId;
  }

  getMainSlides() {
    if (!this.mainSlider) return [];

    return Array.from(this.mainSlider.querySelectorAll('.main-item[data-media-id]'));
  }

  getThumbnailSlides() {
    if (!this.thumbSlider) return [];

    return Array.from(this.thumbSlider.querySelectorAll('.thumb-item[data-target]'));
  }

  setActiveThumbnailByMediaId(mediaId) {
    if (!mediaId) return;

    this.getThumbnailSlides().forEach((thumbnail) => {
      const isActive = thumbnail.getAttribute('data-target') === mediaId;
      const thumbnailButton = thumbnail.querySelector('button');

      thumbnail.classList.toggle('slick-current', isActive);
      if (thumbnailButton) thumbnailButton.toggleAttribute('aria-current', isActive);
    });
  }

  markThumbIfNotScrollable() {
    if (!this.thumbSlider || !$(this.thumbSlider).hasClass('slick-initialized')) return;

    const $slider = $(this.thumbSlider);
    const slideCount = $slider.find('.slick-slide').not('.slick-cloned').length;
    const slidesToShow = $slider.slick('slickGetOption', 'slidesToShow');

    if (slideCount <= slidesToShow) {
      $slider.addClass('thumb--static');
    } else {
      $slider.removeClass('thumb--static');
    }
  }
}

customElements.define('slicky-slider', SlickySliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      const galleryHandlesMedia = this.updateGalleryVisibility();
      if (!galleryHandlesMedia) this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateGalleryVisibility() {
    const mediaGallery = document.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`);
    if (!mediaGallery) return false;

    const groupArrayLength = Number(mediaGallery.dataset.groupArrayLength);
    if (!this.currentVariant || groupArrayLength == 0) return false;

    const thumbSlider = mediaGallery.querySelector('.thumb-slider');
    const main = mediaGallery.querySelector('.main-slider');
    const variantValues = this.currentVariant.options;
    const variantId = this.currentVariant.id;
    const slickSlider = mediaGallery.querySelector('slicky-slider');
    const galleryHandlesMedia = !!main && $(main).hasClass('slick-initialized');
    if (slickSlider && typeof slickSlider.filterByVariantValues === 'function') {
      const firstMediaId = slickSlider.filterByVariantValues(variantValues);
      if (firstMediaId && typeof mediaGallery.setActiveMedia === 'function') {
        mediaGallery.setActiveMedia(firstMediaId, true);
      }

      return !!firstMediaId;
    }

    const groupedSliders = [thumbSlider, main].filter((slider) => slider && $(slider).hasClass('slick-initialized'));

    groupedSliders.forEach((slider) => {
      $(slider).slick('slickUnfilter');

      slider.querySelectorAll('[data-image-group]').forEach((item) => {
        item.classList.add('hide-media');
      });

      variantValues.forEach((value) => {
        slider.querySelectorAll(`[data-image-group="${value}"]`).forEach((item) => {
          item.classList.remove('hide-media');
        });
      });
    });

    requestAnimationFrame(() => {
      if (this.currentVariant?.id !== variantId) return;

      groupedSliders.forEach((slider) => {
        $(slider).slick('slickFilter', function (index, element) {
          return !element.classList.contains('hide-media');
        });
      });

      this.resetGalleryToFirstVisibleMedia(mediaGallery);
    });

    return galleryHandlesMedia;
  }

  resetGalleryToFirstVisibleMedia(mediaGallery) {
    const firstVisibleMedia = mediaGallery.querySelector('.main-slider .main-item[data-media-id]');
    if (!firstVisibleMedia || typeof mediaGallery.setActiveMedia !== 'function') return;

    mediaGallery.setActiveMedia(firstVisibleMedia.getAttribute('data-media-id'), true);
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    // const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    // if (!modalContent) return;
    // const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    // modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const responseSectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    const uiSectionId = this.dataset.section;

    var price_data = this.closest('product-info').querySelector('.price-data');

    var product_info = this.closest('product-info');

    if (product_info) {
      const selling_plan_allocations = this.currentVariant?.selling_plan_allocations?.length > 1
      if (selling_plan_allocations) {
        product_info.classList.add('product__column--has-selling-plan-dropdown')
      } else {
        product_info.classList.remove('product__column--has-selling-plan-dropdown')
      }
    }

    if (price_data) {
      price_data.style.setProperty('--var-product-price', `'$${(this.currentVariant.price / 100.00)}'`)
    }

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${responseSectionId}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const priceMobileDestination = document.getElementById(`price-${this.dataset.section}-mobile`);
        const priceMobileSource = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}-mobile`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (priceMobileSource && priceMobileDestination) priceMobileDestination.innerHTML = priceMobileSource.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        const priceMobile = document.getElementById(`price-${this.dataset.section}-mobile`);
        if (priceMobile) priceMobile.classList.remove('hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${responseSectionId}`);

        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );
        
        // NOTE: commenting this out because it's broken 
        // var klaviyo_show = addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true;
        // console.log('klaviyo_show', klaviyo_show);

        // const klaviyoButton = document.querySelector('.klaviyo-bis-trigger');
        // console.log('klaviyoButton', klaviyoButton);

        // klaviyo_show ? klaviyoButton.classList.remove('hidden') : klaviyoButton.classList.add('hidden')

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId: responseSectionId,
            html,
            variant: this.currentVariant,
          },
        });

        document.dispatchEvent(new CustomEvent('variant-changed', {
          detail: {
            sectionId: uiSectionId,
            originalSectionId: responseSectionId,
            variant: this.currentVariant,
          }
        }));

        
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }

          this.initSlideshowSlick();

        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }


  initSlideshowSlick() {
    const slideshow = this.querySelector('.slideshow');

    this.options = {
      dots: false,
      arrows: true,
      prevArrow: '<button class="slick-prev slick-arrow" aria-label="Next" type="button" ><svg width="30" height="24" aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
      nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" ><svg width="30" height="24" aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></button>',
      infinite: true,
      focusOnSelect: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: this.dataset.autoplay == 'true' ? true : false,
      autoplaySpeed: this.dataset.speed,
      responsive: [
        {
          breakpoint: 989,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    };

    const prev = this.querySelector('.custom-prev');
    const next = this.querySelector('.custom-next');

    if (prev) this.options['prevArrow'] = prev;
    if (next) this.options['nextArrow'] = next;

    $(slideshow).not('.slick-initialized').slick(this.options);


  }

}

customElements.define('product-recommendations', ProductRecommendations);

class FeaturedCollection extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll('.tab-button');
    this.tabsContent = this.querySelectorAll('.tab-content');
    if (this.tabs.length > 0) {
      this.tabs.forEach(dot => dot.addEventListener('click', this.tabClick.bind(this)));
    }
  }

  tabClick(e) {
    const button = e.target.closest('.tab-button');
    this.tabs.forEach(tab => {
      tab.classList.remove('active');
    });
    button.classList.add('active');

    const id = button.dataset.id;
    this.tabsContent.forEach(tab => tab.classList.add('hidden'));
    const activeTab = this.querySelector(`.tab-content[data-id="${id}"]`);
    activeTab.classList.remove('hidden');

    var slideshow = activeTab.querySelector('slick-slider');
    if (slideshow) slideshow.setPosition();

  }
};
customElements.define('featured-collection', FeaturedCollection);


const buttons = document.querySelectorAll(".info-icon");
const exits = document.querySelectorAll(".contact-modal-exit");

buttons.forEach(b => {
  b.addEventListener('click', function (e) {
    const clicked = e.target.closest('.info-icon');
    e.preventDefault();
    // Guard clause
    if (!clicked) return;
    console.log(`.modal-contact-dark-overlay--${clicked.dataset.icon}`);
    document.querySelector(`.modal-contact-dark-overlay--${clicked.dataset.icon}`).style.display = "block";
    document.querySelector(`.contact-modal-container--${clicked.dataset.icon}`).style.display = "block";
    document.querySelector(`.image-wrapper--${clicked.dataset.icon} video`).play();
    document.querySelector(`.image-wrapper--${clicked.dataset.icon} video`).muted = false;
  })
})

exits.forEach(e => {
  e.addEventListener('click', function (e) {
    const clicked = e.target.closest('.contact-modal-exit');
    e.preventDefault();
    // Guard clause
    if (!clicked) return;

    document.querySelector(`.modal-contact-dark-overlay--${clicked.dataset.exit}`).style.display = "none";
    document.querySelector(`.contact-modal-container--${clicked.dataset.exit}`).style.display = "none";
    document.querySelectorAll(".image-wrapper video").forEach(v => {
      v.muted = true;
      v.pause();
    })
  })
})

 class ImageWithText extends HTMLElement {
  constructor() {
     super();

     this.accordions = this.querySelectorAll('.accordion');
      this.accordions.forEach(accordion => {
        accordion.addEventListener('mouseover', (event) => {
          const dataImage = event.target.closest('.accordion').getAttribute('data-image');
          const masterImage = this.querySelector('.media img');
          const dataLink = event.target.closest('.accordion').getAttribute('data-link');
          const masterLink = this.querySelector('.media .image-link');

          if (masterLink) {
            if (dataLink) {
              // Update the href attribute
              masterLink.href = dataLink;}


          }

          if (masterImage) {
            if (dataImage) {
              // Update the src attribute
              masterImage.src = dataImage;

              // Update the srcset attribute
              const oldSrcset = masterImage.getAttribute('srcset');
              if (oldSrcset) {
                const newSrcset = oldSrcset.split(',').map(src => {
                  return src.replace(/[^,]+/, dataImage); // Replace old URL with new one
                }).join(',');
                masterImage.setAttribute('srcset', newSrcset);
              }
            } else {
              // Revert to the original image if no data attribute
              masterImage.src = masterImage.getAttribute('data-original-src'); // Assuming original src is stored in a data attribute
            }
          }


        });
      });

  }

}

customElements.define('image-with-text',  ImageWithText);

class HeaderElement extends HTMLElement {
  connectedCallback() {
    const mainMenu = this.querySelector('.js-primary-menu');
    const secondaryMenu = this.querySelector('.js-secondary-menu');

    if (mainMenu) {
      const menuHeight = mainMenu.offsetHeight;

      this.style.setProperty('--main-menu-height', `${menuHeight}px`);
    }
    
    if (secondaryMenu) {
      const secondMenuHeight = secondaryMenu.offsetHeight;

      this.style.setProperty('--secondary-menu-height', `${secondMenuHeight}px`);
    }
  }
}

customElements.define('header-element', HeaderElement);
class SiteFooter extends HTMLElement {
  constructor() {
    super();
    this.headers = this.querySelectorAll('[data-header]')

    if (this.headers.length > 0) {
      this.headers.forEach((header, index) => {
        header.addEventListener('click', (event) => this.handleHeaderClick(event));

        if (index == 0) {
          header.classList.add('footer-block__heading--mobile-first')
        }
      })
    }
  }

  handleHeaderClick ({ currentTarget }) {
    const { nextElementSibling: content } = currentTarget
    content.classList.toggle('open');
    currentTarget.classList.toggle('open');
  }
}

customElements.define('site-footer',  SiteFooter);
